import { ReactNode } from 'react';
import { Box, Checkbox as MuiCheckbox, makeStyles } from '@material-ui/core';
import FormControlLabel, { FormControlLabelProps } from '@material-ui/core/FormControlLabel';
import { ErrorMessage } from '../helpers';
import { useContextField } from '../../../api';
import { Colors } from '../helpers';

export default ({ label, labelPlacement, name, onChange }: {
    label?: string | ReactNode;
    labelPlacement?: FormControlLabelProps['labelPlacement'];
    name: string;
    onChange?: (checked: boolean) => void;
}) => {
    const classes = useStyles();
    const [field, _, helper] = useContextField<boolean | undefined>(name);

    return <>
        <FormControlLabel
            classes={{ root: classes.root, label: classes.label }}
            labelPlacement={labelPlacement || 'end'}
            label={<Box>{label}</Box>}
            control={<MuiCheckbox
                color="primary"
                checked={field.value}
                name={field.name}
                onChange={(_, checked) => { helper.setValue(checked); onChange && onChange(checked); }}
            />}
        />
        <ErrorMessage name={field?.name} />
    </>
}

const useStyles = makeStyles({
    root: {
        padding: 0,
        margin: 0,
        display: 'flex'
    },
    label: {
        flexGrow: 1,
        color: Colors.Black
    }
}, { name: 'Checkbox' });
